import clsx from 'clsx'
import { type ComponentPropsWithRef, type ElementType } from 'react'

type ScrollAreaProps<T extends ElementType> = ComponentPropsWithRef<T> & { as?: ElementType }

const ScrollArea = (props: ScrollAreaProps<'div'>) => {
    const { className, as: Component = 'div', ...otherProps } = props
    return (
        <Component
            className={clsx(
                'overflow-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-neutral-300 dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500 [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-track]:bg-neutral-100 dark:[&::-webkit-scrollbar-track]:bg-neutral-700',
                className,
            )}
            {...otherProps}
        />
    )
}

ScrollArea.displayName = 'ScrollArea'

export { ScrollArea, type ScrollAreaProps }
